import React from 'react';
import FormulaireSelectionProjet from '../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireVue.module.scss';
import SensorSelector from './SensorSelector';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../UI/MessageErreur/MessageErreur';
import { messageDuChamp } from '../../../../services/schemas/validerFormulaire';

interface CommonPlanningFormFieldsProps {
  projectId: string | number;
  setProjectId: (id: string | number) => void;
  viewName: string;
  viewId?: number;
  setViewName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
  affichageProfil: boolean;
  sensorList?: any[];
  selectedSensors: any[];
  setSelectedSensors: (s: any[]) => void;
  // Erreurs de validation de FormulaireVue, indexées par nom de champ.
  erreurs?: Record<string, string[]>;
}

const CommonPlanningFormFields: React.FC<CommonPlanningFormFieldsProps> = ({
  projectId,
  setProjectId,
  viewName,
  setViewName,
  description,
  setDescription,
  affichageProfil,
  sensorList,
  selectedSensors,
  setSelectedSensors,
  viewId,
  erreurs = {},
}) => {
  return (
    <>
      {/* Première ligne : Projet et Nom de la vue */}
      <div className={`${s.form_row} ${s.align_items_center}`}>
        {/* Le sélecteur rend son label et sa liste à plat : on les regroupe
            avec le message pour qu'il passe sous la liste. */}
        <div className={`${s.col_6} ${styles.style}`}>
          <FormulaireSelectionProjet
            affichageProfil={affichageProfil}
            gererProjetId={setProjectId}
            preconfigurerProjetId={projectId}
          />
          <MessageErreur cle={messageDuChamp(erreurs, 'project_id')} />
        </div>

        <div className={`${s.col_6} ${styles.style}`}>
          <span className={styles.stil2}>{checkMot('view_name')} *</span>
          <input
            type="text"
            className={`${s.form_control} ${
              messageDuChamp(erreurs, 'view_name') ? classeChampEnErreur : ''
            }`}
            placeholder="view_name"
            name="view_name"
            value={viewName}
            disabled={affichageProfil}
            onChange={(e) => setViewName(e.target.value)}
            required
            aria-label={checkMot('view_name')}
          />
          <MessageErreur cle={messageDuChamp(erreurs, 'view_name')} />
        </div>
      </div>

      {/* Deuxième ligne : Description en pleine largeur */}
      <div className={`${s.form_row} ${s.align_items_start}`}>
        <div className={`${s.col_12} ${styles.style}`}>
          <span className={styles.stil2}>{checkMot('description')}</span>
          <textarea
            className={`${s.form_control} ${styles.compact_textarea}`}
            placeholder="description"
            name="description"
            value={description}
            disabled={affichageProfil}
            onChange={(e) => setDescription(e.target.value)}
            aria-label={checkMot('description')}
            rows={1}
          />
        </div>
      </div>

      {/* Troisième ligne : Sélecteur de capteurs si applicable */}
      {sensorList && (
        <div className={`${s.form_row} ${s.align_items_start}`}>
          <div className={`${s.col_12} ${styles.style}`}>
            <SensorSelector
              selectedSensors={selectedSensors}
              sensorList={sensorList}
              setSelectedSensors={setSelectedSensors}
              idView={viewId}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CommonPlanningFormFields;
